import ToolbarPopover from "../../../Navigation/ContextualToolbar/ToolbarPopover/ToolbarPopover";
import React, { useState, useRef } from "react";
import { Input } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

const RenamePopover = ({
  name,
  label,
  onClose,
  iconProps,
  onCommit,
  validateFxn,
  popoverProps,
  inputProps,
  dataTestPrefix,
  triggerTestId,
  confirmBtnTestId,
  newControlTestPrefix = dataTestPrefix,
  fieldTestSuffix
}) => {
  const [error, setError] = useState(null);

  const withFieldSuffix = base => (fieldTestSuffix ? `${base}-${fieldTestSuffix}` : base);

  const openCtrlRef = useRef(null);
  const inputRef = useRef(null);

  const closePopover = () => {
    setError(null);
    openCtrlRef?.current?.setOpen(false);
    if (onClose) onClose();
  };

  const overlayProps = {
    id: "rename-popover-overlay",
    footerProps: {
      "data-testid": withFieldSuffix(`${newControlTestPrefix}-rename-popover`),
      footerActions: {
        cancelAction: () => closePopover(),
        cancelLabel: appstr("Cancel"),
        customAction: {
          onClick: () => startCommit(),
          buttonProps: {
            modifier: "primary",
            dataTestId: confirmBtnTestId ?? withFieldSuffix(`${dataTestPrefix}-rename-confirm-btn`)
          },
          label: appstr("Save")
        }
      }
    }
  };

  const startCommit = () => {
    setError(null);
    const currentName = inputRef?.current?.value ?? "";
    if (validateFxn) {
      let { success, errorResponse } = validateFxn(currentName);
      if (!success) {
        setError(errorResponse ? errorResponse : appstr("InvalidName"));
        return; //TODO: warning/error
      }
    }
    onCommit(currentName);
    closePopover();
  };

  return (
    <ToolbarPopover
      icon={"font"}
      overlayProps={overlayProps}
      iconProps={iconProps}
      otherPopoverProps={{ offsetOptions: -2, openCtrlRef: openCtrlRef, ...popoverProps }}
      key={5}
      triggerTestId={triggerTestId ?? withFieldSuffix(`${dataTestPrefix}-rename-trigger`)}
    >
      <RenameInput
        name={name}
        label={label}
        inputRef={inputRef}
        inputProps={inputProps}
        error={error}
        dataTestId={withFieldSuffix(`${newControlTestPrefix}-rename-input`)}
      />
    </ToolbarPopover>
  );
};

export default RenamePopover;

export const RenameInput = props => {
  return (
    <div style={{ width: "100%" }}>
      <Input
        label={props.label ? props.label : appstr("Rename")}
        ref={props.inputRef}
        placeholder={appstr("Enter name here")}
        size="small"
        status={props.error ? "error" : "default"}
        message={props.error ? props.error : undefined}
        type="text"
        autoFocus
        defaultValue={props.name}
        dataTestId={props.dataTestId}
        {...props.inputProps}
      />
    </div>
  );
};
